import { useUser } from '@platform/shared/hooks';
import * as peApi from '../pe.api';

const usePeUser = (userId: number) => useUser({ userId, userApi: peApi.getUser });
export default usePeUser;
